export const environment = {
  production: false,

  apiUrl: 'https://api.cotral.com/CLHUB.API/api/',
  apiVersionDefault: 'v1.3',

  capaApiUrl : 'https://api.cotral.com/Capa.API/api/',
  capaApiVersionDefault: 'v1.1',
  capaKeycloakRedirectURL: window.location.origin + window.location.pathname + '/capa/',

  CotralAppsOpenId : {
    grant_type: 'password',
    client_id: 'clhub_client',
    client_secret: '62be4547-b2fa-41d7-bd8f-e541660f175f',
    username: 'cotral_apps',
    password: 'Tén@6T',
    scope: 'openid'
  },

  redirectUrl: 'https://clhub.sandbox.cotral.com',
  basehref: '/clhub/',

  keycloakRedirectURL: window.location.origin + window.location.pathname,
  // keycloakBaseURL: 'https://dev.kc.cotral.com',
  // keycloakRealm:  'Cotral',
  // keycloakIssuer: 'https://dev.kc.cotral.com/auth/realms/Cotral',
  // keycloakClient: 'clhub-client',
  // keycloakBroker: 'https://dev.kc.cotral.com/auth/realms/Cotral/broker/azure-ad/token',

  keycloakBaseURL: 'https://auth.cotral.com/auth',
  keycloakRealm:  'Cotral',
  keycloakIssuer: 'https://auth.cotral.com/auth/realms/Cotral',
  keycloakClient: 'clhub-client',
  keycloakBroker: 'https://auth.cotral.com/auth/realms/Cotral/broker/azure-ad/token', 
   
  keycloakRequiereHttps: true
};